import $ from "jquery";

if ($(".js-btn-switch").length) {
  $(".js-btn-switch").on("click", function () {
    $(".js-slide-close").text("Continue");
  });
}

if ($(".js-slide-close").length) {
  $(".js-slide-close").on("click", function () {
    $(".js-slide-close").text("Go Back");
  });
}

const slideToggle = ($element) => {
  const target = $element.data("target");
  const speed = $element.data("speed");
  $element.toggleClass("toggled");
  $("." + target).slideToggle(speed);
};

$(".js-slidetoggle").on("click", function () {
  slideToggle($(this));
  $(".toggled")
    .not(this)
    .each(function () {
      slideToggle($(this));
    });
});

// Toggle class
$(".js-toggle-class").click(function () {
  let toggleClass = $(this).data("class");
  if ($(this).attr("data-target")) {
    let target = $(this).data("target");
    $(target).toggleClass(toggleClass);
    $(this).toggleClass("toggled");
  } else {
    $(this).toggleClass(toggleClass);
  }
  return false;
});

// Focus
$(".js-focus").click(function () {
  let target = $(this).data("focus");
  let $target = $(target);
  $target.focus();
  $target.val($target.val());
});

// Prevent disabled links/buttons
$(".btn, a, button, input[type=submit]").click(function (e) {
  if ($(this).hasClass("btn-disabled") || $(this).hasClass("disabled")) {
    e.preventDefault();
    return false;
  }
});

// Responsive video wrapper
$(".iframe[src*='vimeo.com'], .iframe[src*='youtube.com']")
  .not(".js-no-maintain-ratio")
  .each(function () {
    let width = parseInt($(this).attr("width"));
    let height = parseInt($(this).attr("height"));
    let aspectRatio = (height / width) * 100;
    let wrapper = $(
      "<div class='iframe-container iframe-container--maintain-ratio'></div>"
    ).css("padding-bottom", aspectRatio + "%");
    $(this).wrap(wrapper);
  });

// Responsive tables
$(".js-add-responsive-table-labels").each(function () {
  let currentTable = $(this);

  if ($(this).find("th").length) {
    $(this)
      .find("th")
      .each(function (i) {
        let label = $(this).text();
        $(this).addClass("table-label");
        $(currentTable)
          .find("tr")
          .each(function () {
            $(this).find("td").eq(i).attr("data-label", label);
          });
      });
  }
});

// Accordions
if ($(".accordion-group").length) {
  let $accordionHead = $(".accordion-head");
  if ($accordionHead.length) {
    // Bind to the show event
    $(".accordion-head").on("show.r.dropdown", function () {
      $(this).addClass("active");
    });

    // Bind to the hide event
    $(".accordion-head").on("hide.r.dropdown", function () {
      $(this).removeClass("active");
    });
  }
}

$(".js-select").on("click", function (e) {
  e.preventDefault();

  let $this = $(this);
  let targetSelect = $this.data("targetSelect");
  let targetSelectValue = $this.data("targetSelectValue");

  $(targetSelect + " option[value=" + targetSelectValue + "]").prop(
    "selected",
    true
  );
});
